import { esES as userGroupsTranslations } from '../UserGroup/es-ES';
import type { IGroupsTranslations } from '@/Pages/Groups/types/groupsTranslations.types';

const esES: IGroupsTranslations = {
  route: 'Grupos',
  chooseGroup: {
    title: 'Crear grupos',
    description: 'Selecciona el tipo de grupo que deseas crear.',
    cards: {
      devices: {
        title: 'Dispositivos',
        description:
          'Crea grupos de dispositivos para ayudarte a segmentar o categorizar según tus necesidades.',
      },
      users: {
        title: 'Usuarios',
        description:
          'Crea grupos de usuarios para segmentar qué usuarios podrán ver ciertos dispositivos.',
      },
    },
  },
  modals: {
    newGroupAssignment: {
      title: '¿Desea asignarlo a un nuevo grupo de usuarios?',
      description: 'Será dirigido al proceso de creación de un nuevo grupo.',
      cancelButton: 'No',
      confirmButton: 'Sí',
    },
    deviceGroupLink: {
      title: '¡Atención!',
      description:
        'Para garantizar el buen funcionamiento de este nuevo grupo, es importante vincularlo a un grupo de dispositivos. ¿Desea hacer esta asociación ahora?',
      cancelButton: 'No',
      confirmButton: 'Sí',
    },
    redirecting: {
      title: 'Está siendo redirigido a la pantalla de creación de grupos',
      description:
        'No se preocupe, la configuración que ya ha definido está guardada y podrá revisarla más tarde antes de finalizar la creación del grupo.',
    },
  },
  overview: {
    title: 'Resumen de grupos',
    description: 'Verifica los parámetros elegidos para los grupos.',
    groupData: {
      title: 'Datos del grupo',
      groupName: 'Nombre del grupo',
      groupDescription: 'Descripción',
    },
    hierarchy: {
      title: 'Jerarquía',
      belongsTo: 'Pertenecerá al grupo:',
    },
    permissions: {
      title: 'Permisos de grupos',
      administrators: 'Administradores',
      viewers: 'Perfiles solo lectura',
    },
    devicesCount: {
      title: 'Dispositivos',
    },
    assignedGroups: {
      assignOne: {
        title: 'Grupo asignado 1',
      },
      assignTwo: {
        title: 'Grupo asignado 2',
      },
      groupName: 'Nombre del grupo',
      description: 'Descripción',
      users: 'Usuarios',
      user: 'usuario',
      permissions: {
        label: 'Permisos de grupos',
        administrators: 'Administradores:',
        viewers: 'Perfiles solo lectura:',
      },
    },
    submitButton: 'Hecho',
  },
  userGroups: userGroupsTranslations,
};

export { esES };
